import { Flex, Image, Link, Text } from "@chakra-ui/react";
import iconDelete from "../../assets/images/projectManagement/icon-delete.svg";
import { DownloadIcon } from "@chakra-ui/icons";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

export const formatTablePopup = (value, key) => {
  switch (key) {
    case "name":
      return <Text textAlign={"start"}>{value}</Text>;
    case "position":
      return <Text textAlign={"start"}>{value}</Text>;
    case "commission":
      return <Text textAlign={"center"}>{value}</Text>;
    case "path":
      return (
        <Link
          cursor={"pointer"}
          href={value ? `${value}` : ""}
          // href={value ? `${baseURL}/${value}` : ""}
          target="_blank"
          textAlign={"center"}
        >
          <DownloadIcon color={"var(--color-secondary)"} />
        </Link>
      );
    default:
      return (
        <Flex justifyContent={"flex-end"}>
          <Image src={iconDelete} />
        </Flex>
      );
  }
};
